
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Download, MessageSquare, Briefcase, PlusCircle, Settings, Wrench, ChartColumn, RefreshCcw } from 'lucide-react';
import { ActionCard } from '@shared/components/ActionCard';
import { useTranslation } from 'react-i18next';

export const QuickActionsGrid = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <h2 className="text-lg font-bold text-slate-800 mb-4">{t("Quick Actions")}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <ActionCard title={t("Pay Bill")} icon={<CreditCard size={24} />} colorClass="bg-blue-600" onClick={() => navigate('/dashboard/billing')} />
        <ActionCard title={t("Download Bill")} icon={<Download size={24} />} colorClass="bg-indigo-600" onClick={() => navigate('/dashboard/billing')} />
        <ActionCard title={t("Raise Complaint")} icon={<MessageSquare size={24} />} colorClass="bg-rose-600" onClick={() => navigate('/dashboard/requests/create/complaint')} />
        <ActionCard title={t("Service Request")} icon={<Wrench size={24} />} colorClass="bg-amber-500" onClick={() => navigate('/dashboard/requests/create/service')} />
        <ActionCard title={t("View Usage")} icon={<ChartColumn size={24} />} colorClass="bg-teal-600" onClick={() => navigate('/consumption')} />
        <ActionCard title={t("Setup AutoPay")} icon={<RefreshCcw size={24} />} colorClass="bg-green-600" onClick={() => navigate('/dashboard/billing?tab=autopay')} />
      </div>
    </div>
  );
};
